up.compiler("lightgallery", function(element, data){
  let options = {
    licenseKey: '100759DC-4B74-49F4-8193-9752883C9621',
    plugins: [lgVideo, lgThumbnail],
    videojs: true,
    controls: true,
    download: false,
    thumbnail: true,
  };

  let lightgallery = lightGallery(element, options);

  return function(){
    lightgallery.destroy();
  }
})
